import React, { useEffect } from "react";
import logo from "../Assets/Logo/logo.webp";
import { InlineWidget } from "react-calendly";

const Apply = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    window.fbq("track", "Lead");
  }, []);

  return (
    <>
      <section>
        <div className="container">
          <div className="mt-5">
            <div className="alignment">
              <img src={logo} alt="Social Eagle" className="calenderlogo" />
            </div>
            <div className="mt-5">
              <InlineWidget url="https://calendly.com/d/cm2v-zs7-vtf" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Apply;
